import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FlexModule } from '@ngbracket/ngx-layout';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';

import { TrackClickModule } from '@libs/src/track-click/track-click.module';

import { TtcSegmentedComponent } from './ttc-segmented.component';

@NgModule({
  declarations: [TtcSegmentedComponent],
  exports: [TtcSegmentedComponent],
  imports: [
    CommonModule,
    FlexModule,
    FormsModule,
    MatIconModule,
    NzSegmentedModule,
    TrackClickModule,
  ],
})
export class TtcSegmentedModule {}
